import { Directive, input } from '@angular/core';

@Directive()
export abstract class BaseSidebarHeaderAdditionalInfoComponent<T> {
    readonly item = input.required<T>();

    abstract onItemSet(): void;
}
